import type { JSX } from "react";

import {
    IBasket,
    IBasketLine,
    IOptionCode,
    IProduct,
} from "../../../models/catalogue";
import { IProductAPIURL } from "../../../models/nominals";
import { notEmpty } from "../../../utils/functional";

type TProductUpsell = {
    placement: "in-details" | "post-details";
    hideBottomBorder?: boolean;
    content: JSX.Element;
};

export type TGetProductUpsell = (
    basket: IBasket,
    line: IBasketLine,
    addBasketLine: (
        productURL: IProductAPIURL,
        qty?: number,
    ) => Promise<IBasket>,
) => TProductUpsell | null;

export const listOptions = (
    product: IProduct,
): Array<{
    key: IOptionCode;
    name: string;
    value: string | readonly string[];
    display_names?: Readonly<Record<string, string>> | null;
}> => {
    const attributes = product.attributes;
    const optionKeys = attributes.product_options?.value || [];
    return optionKeys
        .map((key) => {
            const attr = attributes[key];
            if (!attr) {
                return;
            }
            return {
                key: key,
                name: attr.name,
                value: attr.value,
                display_names: attr.display_names,
            };
        })
        .filter(notEmpty);
};
